import { create } from 'zustand';
import { ApiUtils, type MessageItemEntity, MessagesApi } from '@shared/api';

interface UseThreadStore {
  loading: boolean;
  data: MessageItemEntity[];
  error: string | null;
  getThread: (threadId: string, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useThreadStore = create<UseThreadStore>((set) => ({
  loading: false,
  data: [],
  error: null,

  getThread: async (threadId, signal) => {
    try {
      set({ loading: true, error: null });
      const result = await MessagesApi.getThread(threadId, signal);
      set({ loading: false, data: result.data || [] });
    } catch (error) {
      set({ loading: false, error: ApiUtils.getApiError(error) });
    }
  },

  clear: () => set({ loading: false, data: [], error: null }),
}));
